<template>
  <div class="ya-te-note px-4 py-2 text-left text-co-gray-500 sm:px-0 sm:text-center">
    ※LINEヤフーテックアカデミーはLINEヤフーとテックアカデミー（ブリューアス社運営）が共同開発・運営するプログラミングスクールです
  </div>
</template>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');
</style>
